//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";
const moment = require('moment');

export default {
  name: "advance-list",
  data(vm) {
    return {
      pdfBlob: null,
      pdfObj: null,
      dialogPDF: false,
      expanded: [],
      dataforprint: {
        title: "Dej-Udom & Associates Ltd.",
        subtitle: "Employee Time Attendance Report",
        sumary_overview: "Summary Overview",
        sumary_overview_details1: "Total Working Days: ",
        sumary_overview_details2: "Days Present: ",
        sumary_overview_details3: "Days Absent (No check-in): ",
        sumary_overview_details4: "Approved Leave Days: ",
        sumary_overview_details5: "Late Check-in Days: ",
        sumary_overview_details6: "Early Check-out Days: ",
        sumary_overview_details7: "Average Check In Time: ",
        sumary_overview_details8: "Average Check Out Time: ",
        sumary_overview_details9: "Total Hours Worked: ",
        sumary_overview_details10: "Total Attendance Missing Hours: ",
        sumary_overview_details11: "Average Daily Working Hours: ",
        details_left1: "Employee: ",
        details_left2: "Position: ",
        details_left3: "Department: ",
        details_left4: "Period: ",
        details_left5: "Report Date: ",
        details_right1: "Total Leave Taken: ",
        details_right2: "Total Leave Quota: ",
        details_right3: "Total Adjacent to Holiday: ",
        details_right4: "Remark: ",
        title_graph: "Attendance Missing Hours (Monthly)",
        leave_summary: "Leave Summarry",
        leave_log_details: "",
      },
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      desserts: [],
      emp_id: 0,
      emp_list: [],
      dep_list_search: [],
      emp_list_search: [],
      dep_id: 0,
      dep_list: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],
      datefrom: null,
      dateto: null,
      dateCurrent: this.formatDateday(new Date().toISOString().substr(0, 10)),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        {
          text: "Employee Name",
          value: "fullnameen",
          class: "bg-colorth tabletextwhite",
          width: "120px"
        },
        {
          text: "Department",
          value: "department_name",
          class: "bg-colorth tabletextwhite",
          width: "100px"
        },
        {
          text: "Position",
          value: "position_name",
          class: "bg-colorth tabletextwhite",
          width: "100px"
        },
        {
          text: "Total Hours Worked",
          value: "total_hours_worked",
          class: "bg-colorth tabletextwhite",
          width: "100px"
        },
        {
          text: "Total Attendance Missing Hours",
          value: "total_attendance_missing_hours",
          class: "bg-colorth tabletextwhite",
          width: "100px",
        },
        {
          text: "Average Daily Working Hours",
          value: "average_daily_working_hours",
          class: "bg-colorth tabletextwhite",
          width: "150px",
        },
        {
          text: "",
          value: "data-table-expand",
          class: "bg-colorth tabletextwhite",
        },
      ],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      jobTitle_list: [],
      searchCharge: null,
      searchChargeJob: null,
      searchEmp: [],
      delete_id: 0,
      dialogDeleteActivity: false,
    };
  },

  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  components: {
    SuccessDialog,
    PdfPreviewDialog,
  },
  beforeUpdate() { },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);


    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.setStartAndEndOfMonth();
    await this.loadEmpData();
    await this.loadDepData();
    await this.loadCompany();
    await this.waitForPdfMake();


    this.$hideLoader();
  },
  methods: {
    async printpdf() {
      //  this.desserts = [];
      this.$showLoader();
      await this.previewPDF();
      this.$hideLoader();
      return;
      var dataitem = {
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        datefrom: this.datefrom,
        dateto: this.dateto,
        emp_id: this.emp_id,
        dep_id: this.dep_id,
      }

      const result = await api.print_getAllCheckInOutEmployeeTimeattendancereport({
        params: dataitem
      });
      this.$hideLoader();

      if (result.data.length > 0) {
        this.desserts = result.data;
        this.$hideLoader();
        await this.previewPDF();
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Show data ",
          "Data not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.$hideLoader();

    },

    getFileName() {
      // const f = this.computedDateFromFormatted;
      // const t = this.computedDateToFormatted;
      const f = this.datefrom;
      const t = this.dateto;
      const emp = this.emp_list.find((x) => x.id === this.emp_id);
      const name = emp ? emp.name.replace(/[\\/:*?"<>|]/g, "-").trim() : "";

      return name
        ? `Employee_Attendance_Report_${name}_${f}_${t}.pdf`
        : `Employee_Attendance_Report_${f}_${t}.pdf`;
    },
    async previewPDF() {
      if (!this.pdfMakeReady) return alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
      if (this.desserts.length < 1) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "No Data", "Please search before printing.", "text-h5 red--text text-center");
        return;
      }

      this.$showLoader();
      try {
        const docDefinition = await this.generateDocDefinition(this.desserts);
        // pdfMake.createPdf(docDefinition).open();

        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          this.pdfBlob = blob;
          this.dialogPDF = true;
          this.$hideLoader();
        });
      } catch (e) {
        this.$hideLoader();
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + e.message);
      }
    },
    async generateDocDefinition(datajsonprint) {
      const mainStatement = await this.generateMainStatement(datajsonprint);

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 20, 40, 20],
        content: mainStatement,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },
    async generateMainStatement(datajsonprint) {
      let mainContent = [];

      // ===== หน้าที่ 1: Employee Time Off Report =====
      datajsonprint.forEach(async (x, i) => {
        const chartData = await this.prepareChartData(x.details);
        mainContent.push(
          // Header บริษัท + CONFIDENTIAL
          {
            columns: [
              {
                width: "*",
                stack: [
                  {
                    text: "",
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                width: 100,
                text: "CONFIDENTIAL",
                fontSize: 10,
                bold: true,
                color: "red",
                fillColor: "red",
                alignment: "center",
                margin: [0, 0, 0, 0],
              },
            ],
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                text: this.dataforprint.title || "",
                fontSize: 16,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              {
                text: this.dataforprint.subtitle || "",
                fontSize: 10,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
            ],
            margin: [0, 0, 0, 0],
          },

          // ข้อมูลพนักงาน (Employee Information)
          {
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: [
                      { text: this.dataforprint.details_left1, fontSize: 9, bold: true },
                      { text: x.fullnameen ? x.fullnameen : x.fullnameth || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left2, fontSize: 9, bold: true },
                      { text: x.position_name || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left3, fontSize: 9, bold: true },
                      { text: x.department_name || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left4, fontSize: 9, bold: true },
                      { text: `${this.computeddatefromFormatted} - ${this.computeddateToFormatted}` || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left5, fontSize: 9, bold: true },
                      {
                        text: this.dateCurrent || new Date().toLocaleDateString("en-GB"),
                        fontSize: 9,
                      },
                    ],
                  },
                ],
              },
              // {
              //   width: "50%",
              //   stack: [
              //     {
              //       text: [
              //         { text: "\u00A0", fontSize: 9 },
              //         { text: "\u00A0", fontSize: 9, bold: true },
              //       ],
              //       alignment: "right",
              //       margin: [0, 0, 0, 2],
              //     },
              //     {
              //       text: [ 
              //         { text: this.dataforprint.details_right1, fontSize: 9 },
              //         { text: x.total_useleave_text || "0 Days", fontSize: 9, bold: true },
              //       ],
              //       alignment: "right",
              //       margin: [0, 0, 0, 2],
              //     },
              //     {
              //       text: [
              //         { text: this.dataforprint.details_right2, fontSize: 9 },
              //         { text: x.total_quota_text || "0 Days", fontSize: 9, bold: true },
              //       ],
              //       alignment: "right",
              //       margin: [0, 0, 0, 2],
              //     },
              //     {
              //       text: [
              //         { text: this.dataforprint.details_right3, fontSize: 9 },
              //         { text: x.leave_logs_details?x.leave_logs_details.filter(item => item.holiday !== undefined).length:0 || 0, fontSize: 9, bold: true },
              //       ],
              //       alignment: "right",
              //       margin: [0, 0, 0, 2],
              //     },
              //     {
              //       text: [
              //         { text: this.dataforprint.details_right4, fontSize: 9 },
              //         { 
              //           text:this.getRemarkWording(x)|| "OK", 
              //           fontSize: 9, 
              //           bold: true,
              //           color: this.getRemarkColor(x)
              //         },
              //       ],
              //       alignment: "right",
              //     },
              //   ],
              // },
            ],
            margin: [0, 0, 0, 20],
          },



          {
            table: {
              widths: ["100%"],
              body: [
                [{
                  stack: [
                    {
                      text: this.dataforprint.sumary_overview || "",
                      bold: true,
                      fontSize: 14,
                      alignment: 'left',
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  margin: [10, 0, 10, 0],
                },
                ]
              ]
            },
            layout: "noBorders",
            fillColor: "#f5f5f5", // สีพื้นหลังต้องใส่นี่!
            margin: [0, 0, 0, 0]
          },
          //ข้อมูล summary overview

          {
            table: {
              widths: ["50%", "50%"],
              body: [
                [
                  {
                    stack: [
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details1, fontSize: 9, bold: true },
                          { text: x.total_working_days || "0", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details2, fontSize: 9, bold: true },
                          { text: x.days_present || "0", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details3, fontSize: 9, bold: true },
                          { text: x.days_absent || "0", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details4, fontSize: 9, bold: true },
                          { text: `${x.total_approved_leave_days}` || "0", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details5, fontSize: 9, bold: true },
                          { text: x.late_checkin_days || "0", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details6, fontSize: 9, bold: true },
                          { text: x.early_checkout_days || "0", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                      },
                    ]
                  },
                  {
                    stack: [
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details7, fontSize: 9, bold: true },
                          { text: x.avg_checkindate || "0 Days", fontSize: 9 },
                        ],
                        alignment: "right",
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details8, fontSize: 9, bold: true },
                          { text: x.avg_checkoutdate || "0 Days", fontSize: 9 },
                        ],
                        alignment: "right",
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details9, fontSize: 9, bold: true },
                          { text: x.total_hours_worked || "0 hrs", fontSize: 9 },
                        ],
                        alignment: "right",
                        margin: [10, 0, 10, 2],
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details10, fontSize: 9, bold: true },
                          { text: x.total_attendance_missing_hours || "0 hrs", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                        alignment: "right",
                      },
                      {
                        text: [
                          { text: this.dataforprint.sumary_overview_details11, fontSize: 9, bold: true },
                          { text: x.average_daily_working_hours || "0 hrs/day", fontSize: 9 },
                        ],
                        margin: [10, 0, 10, 2],
                        alignment: "right",
                      },
                    ]
                  }
                ]
              ]
            },
            layout: "noBorders",
            fillColor: "#f5f5f5", // สีพื้นหลังต้องใส่นี่!
            margin: [0, 0, 0, 20]
          },

          // กราฟ Leaves Taken Days (Monthly) - Placeholder
          {
            stack: [
              {
                text: this.dataforprint.title_graph,
                fontSize: 12,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              }
            ],
            margin: [0, 0, 0, 0],
          },
          // {
          //   text: "Leaves Taken Days (Monthly)",
          //   fontSize: 12,
          //   bold: true,
          //   margin: [0, 0, 0, 10],
          // },
          {
            columns: [
              {
                width: 30,
                stack: this.generateYAxisLabels(chartData.values),
                margin: [0, 5, 0, 0]
              },
              {
                width: '*',
                stack: [
                  {
                    canvas: this.generateBarChartCanvas(chartData.months, chartData.values),
                    margin: [0, 0, 0, 5]
                  },
                  {
                    columns: this.generateXAxisLabels(chartData.months),
                    margin: [0, 5, 0, 0]
                  }
                ]
              }
            ],
            margin: [0, 0, 0, 0],
          },

          // Page Break
          // { text: "", pageBreak: "before" },

          // ===== หน้าที่ 2: Leave Log Details =====

          // Header บริษัท (ซ้ำ)
          // {
          //   columns: [
          //     {
          //       width: "*",
          //       stack: [
          //         {
          //           text: this.dataforprint.title || "Dej-Udom & Associates Ltd.",
          //           fontSize: 16,
          //           bold: true,
          //           margin: [0, 0, 0, 2],
          //         },
          //         {
          //           text: this.dataforprint.subtitle || "Employee Time Off Report",
          //           fontSize: 10,
          //           margin: [0, 0, 0, 0],
          //         },
          //       ],
          //     },
          //     {
          //       width: 100,
          //       text: "CONFIDENTIAL",
          //       fontSize: 10,
          //       bold: true,
          //       color: "white",
          //       fillColor: "red",
          //       alignment: "center",
          //       margin: [0, 0, 0, 0],
          //     },
          //   ],
          //   margin: [0, 0, 0, 10],
          // },

          // ชื่อพนักงาน
          // {
          //   text: [
          //     { text: "Employee: ", fontSize: 10 },
          //     { text: this.header.employee_name || "", fontSize: 10, bold: true },
          //   ],
          //   margin: [0, 0, 0, 20],
          // },

          // Leave Log Details Title
          {
            text: this.dataforprint.leave_log_details,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10],
          },

          // Leave Log Details Table
          {
            table: {
              headerRows: 1,
              widths: [50, 50, 50, 60, 60, 60, 60, 60],
              body: [
                [
                  {
                    text: "Date",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Check In",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Check Out",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Duration (hours)",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Missing (hours)",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Attendance Status",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Leave Type",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Notes",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                ],
                ...x.details.map((log) => [
                  {
                    text: `${log.date_show ? log.date_show : "-"}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.h_name ? "-" : log.daytype ? "-" : log.time_from_show ? log.time_from_show : "-"}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.h_name ? "-" : log.daytype ? "-" : (Number(log.ischeckedout) == 0) ? "-" : log.time_to_show ? log.time_to_show : "-"}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.h_name ? "-" : log.daytype ? "-" : (Number(log.ischeckedout) == 0) ? "-" : log.duration_hours ? log.duration_hours : "-"}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.h_name ? "-"
                      : log.daytype ? "-"
                        : (Number(log.ischeckedout) == 0) ? "-"
                          : (log.missing_hours_number && Number(log.missing_hours_number) > 0) ? log.missing_hours
                            : "-"
                      }` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.h_name ? log.h_name
                      : log.attendance_status ? log.attendance_status
                        : log.daytype ? log.daytype
                          : (!log.time_from_show && !log.attendance_status) ? "Absent"
                            : (Number(log.ischeckedout) == 0) ? "Present"
                              : log.late_checkin_days ? log.late_checkin_days
                                : log.late_checkout_days ? log.late_checkout_days
                                  : (log.missing_hours_number && Number(log.missing_hours_number) <= 0) ? "Present" : "Early Check-Out"
                      }` || "-",
                    fontSize: 8,
                    color: log.h_name ? "purple"
                      : log.attendance_status ? "#0A7EA5"
                        : log.daytype ? "purple"
                          : (!log.time_from_show && !log.attendance_status) ? "red"
                            : (Number(log.ischeckedout) == 0) ? ""
                              : log.late_checkin_days ? "orange"
                                : log.late_checkout_days ? "orange"

                                  : (log.missing_hours_number && Number(log.missing_hours_number) <= 0) ? "" : "orange",
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.leave_type_name ? log.leave_type_name
                      : "-"}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: `${log.leave_description ? log.leave_description : "-"}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                ]),
              ],
            },
            // layout: "lightHorizontalLines",
            layout: {
              hLineWidth: function (i, node) {
                // เส้นบนสุด (i == 0) และเส้นล่างสุด (i == node.table.body.length)
                // return (i === 0 || i === node.table.body.length) ? 1 : 0;
                return 1;
              },
              vLineWidth: function (i, node) {
                // เส้นซ้ายสุด (i == 0) และ ขวาสุด (i == node.table.widths.length)
                return (i === 0 || i === node.table.widths.length) ? 1 : 0;
              },
              // hLineWidth: function (i, node) {
              //   return 1;
              // },
              // vLineWidth: function (i, node) {
              //   return 1;
              // },
              hLineColor: function (i, node) {
                return '#000000';
              },
              vLineColor: function (i, node) {
                return '#000000';
              }
            },
          },
          { text: "", pageBreak: i == this.desserts.length - 1 ? undefined : "before" },

        );
        if (i == this.desserts.length - 1) {
          //  return mainContent;
        }
      });
      return mainContent;

    },
    async prepareChartData(leaveLogsDetails) {
      const months = this.months;

      // สร้าง array สำหรับเก็บจำนวนวันลาของแต่ละเดือน
      const values = new Array(12).fill(0);

      if (!leaveLogsDetails || leaveLogsDetails.length === 0) {
        return { months, values };
      }

      // วนลูปนับจำนวนวันลาในแต่ละเดือน
      leaveLogsDetails.forEach(log => {
        if (log.date_show) {
          // แปลงวันที่จาก format DD/MM/YYYY
          const dateParts = log.date_show.split(' ')[0].split('/');
          if (dateParts.length === 3) {
            const month = parseInt(dateParts[1]) - 1; // เดือน 0-11

            // แปลง leave_time เป็นตัวเลข (เช่น "1 Day" -> 1, "4 Hrs" -> 0.5)
            // || log.event_name
            const duration = this.parseLeaveDuration(
              log.h_name ? 0
                : log.daytype ? 0
                  : (!log.time_from_show && !log.attendance_status) ? 8
                    : (Number(log.ischeckedout) == 0) ? 0

                      : (log.missing_hours_number && Number(log.missing_hours_number) >= 0) ? Number(log.missing_hours_number) : 0,
            );
            values[month] += duration;
          }
        }
      });
      return { months, values };
    },
    async waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert(
            "ไม่สามารถโหลดระบบ PDF ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต"
          );
        }
      }, 10000);
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setStartAndEndOfMonth() {
      const today = new Date();

      // วันที่ 1 ของเดือนนี้
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.datefrom = moment(startOfMonth).format("YYYY-MM-DD");;

      // วันที่สุดท้ายของเดือนนี้
      const endOfMonth = new Date();
      // const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.dateto = moment(endOfMonth).format("YYYY-MM-DD");

      // await this.loaddata();
      // await this.searchdata();
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();

      this.authorize = res_get.data;
    },

    async loaddata() {
      var dataitem = {
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        datefrom: this.datefrom,
        dateto: this.dateto,
        emp_id: 0,
        dep_id: 0,
      }
      const resData = await api.getAllCheckInOutByDep({
        params: dataitem
      })
      this.dataAll = resData.data;
      this.mDataArray = resData.data;
      this.$hideLoader();
    },
    async loadEmpData() {
      const resultList = await api.getAccountsByCompanyCIO(Number(localStorage.getItem(server.COMPANYID)));
      this.emp_list = resultList.data;
      this.emp_list_search = resultList.data;
    },
    async loadDepData() {
      const resultDepList = await api.getNewAllDepartment_By_CompanyID(Number(localStorage.getItem(server.COMPANYID)));
      this.dep_list = resultDepList.data;
      this.dep_list_search = resultDepList.data;

    },
    async changeEmp() {
      if (this.emp_id != 0 && this.emp_id != null) {
        this.dep_id = 0;
        let aaa = this.emp_list_search.find(emp => emp.id === this.emp_id);
        this.dep_id = (this.dep_list_search.find(dpm => dpm.id === aaa.department_i_d)?.id) ?? 0;
      } else {
        this.emp_list = this.emp_list_search;
        this.dep_list = this.dep_list_search;
      }
    },
    async changeDep() {
      if (this.dep_id != 0 && this.dep_id != null) {
        this.emp_id = 0;
        this.emp_list = this.emp_list_search.filter(emp => emp.department_i_d === this.dep_id);
      } else {
        this.emp_list = this.emp_list_search
      }
    },
    async searchdata() {
      // ===== ตรวจสอบช่วงวันที่ =====
      if (!this.datefrom || !this.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Date",
          "Please select Date From and Date To",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (moment(this.datefrom).isAfter(moment(this.dateto), "day")) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Date",
          "Date From must be less than Date To",
          "text-h5 red--text text-center"
        );
        return;
      }
      // ============================
      let findemp_id;
      if (this.emp_id || this.emp_id !== 0) {
        findemp_id = [this.emp_id]
      } else {
        findemp_id = this.emp_list.map(item => item.id)
      }
      this.$showLoader();
      var dataitem = {
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        datefrom: `${this.datefrom} 00:00:00`,
        dateto: `${this.dateto} 23:59:59`,
        emp_id: findemp_id,
        dep_id: this.dep_id,
      }
      const resData = await api.print_getAllCheckInOutEmployeeTimeattendancereport({
        params: dataitem
      });
      // console.log(resData.data)
      this.desserts = resData.data;
      // this.dataAll = resData.data;
      // this.mDataArray = resData.data;
      this.$hideLoader();
    },
    openPreviewMaps(data) {
      // ใช้ Regular Expression เพื่อดึงพิกัดจากข้อมูล
      const regex = /([\d.-]+)\s*,\s*([\d.-]+)/;
      const matches = data.match(regex);

      if (matches) {
        const lat = matches[1];  // ละติจูด (latitude)
        const lng = matches[2];  // ลองจิจูด (longitude)

        // สร้าง URL สำหรับเปิด Google Maps ที่จุดเดียว
        const url = `https://www.google.com/maps?q=${encodeURIComponent(lat)},${encodeURIComponent(lng)}`;
        window.open(url, '_blank');
      } else {
        console.error('ไม่พบพิกัดในข้อมูล');
      }
    },
    getRemarkWording(item) {
      if (item.total_day_sickleave >= 5 || item.total_percent_sickleave >= 50) {
        return "Monitor Sick Leave";
      } else if (item.total_useleave >= item.total_quota || item.total_percent > 100) {
        return "No Leave Taken";
      }
      else if (item.total_percent > 90) {
        return "Approaching Limit";
      }
      else if (item.total_percent >= 70 && item.total_percent <= 90) {
        return "Monitor Usage";
      }
      else if (item.total_percent < 70) {
        return "OK";
      } else {
        return "";
      }
    },
    getRemarkColor(item) {
      if (item.total_day_sickleave >= 5 || item.total_percent_sickleave >= 50) {
        return "orange";
      } else if (item.total_useleave >= item.total_quota || item.total_percent > 100) {
        return "red";
      }
      else if (item.total_percent > 90) {
        return "red";
      }
      else if (item.total_percent >= 70 && item.total_percent <= 90) {
        return "orange";
      }
      else if (item.total_percent < 70) {
        return "green";
      } else {
        return "black";
      }
    },
    parseLeaveDuration(leaveTime) {
      if (!leaveTime) return 0;

      let totalDays = 0;
      const hours = leaveTime;
      // const hours = parseInt(leaveTime);
      // totalDays += hours / 8; // แปลงชั่วโมงเป็นวัน (8 ชม. = 1 วัน)
      totalDays += hours;


      return totalDays <= 0 ? 0 : totalDays;
    },
    getRandomInt() {
      let randoms = [];
      for (let index = 0; index < 12; index++) {
        randoms.push(Math.floor(Math.random() * (50000 - 5 + 1)) + 5);
      }
      return randoms;
    },
    generateYAxisLabels(values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const labels = [];

      for (let i = 10; i >= 0; i--) {
        const y = ((10 - i) * chartHeight) / 10;

        labels.push({
          text: `${Math.round((i * maxValue) / 10)}`,
          fontSize: 8,
          alignment: 'left',
          absolutePosition: { x: 55, y: y + 290 }, // ปรับ x, y ตามตำแหน่งจริง
          margin: [0, 0, 0, 0]
        });
      }

      return labels;
    },

    // ฟังก์ชันสร้าง X-axis labels
    generateXAxisLabels(months) {
      return months.map(month => ({
        width: '*',
        text: month.substring(0, 3),
        fontSize: 7,
        alignment: 'center'
      }));
    },

    // ฟังก์ชันสร้าง canvas สำหรับแท่งกราฟและ grid เท่านั้น
    generateBarChartCanvas(months, values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const chartWidth = 480;
      const barWidth = (chartWidth / months.length) - 8;
      const baseY = chartHeight;
      const colors = [
        "#EF5350",
        "#AB47BC",
        "#5C6BC0",
        "#42A5F5",
        "#26C6DA",
        "#66BB6A",
        "#9CCC65",
        "#FFA726",
        "#FF7043",
        "#8D6E63",
        "#EC407A",
        "#29B6F6"
      ];

      let canvas = [];

      // วาด Grid Lines แนวนอน
      for (let i = 0; i <= 10; i++) {
        const y = (chartHeight / 10) * (10 - i);

        canvas.push({
          type: 'line',
          x1: 0,
          y1: y,
          x2: chartWidth,
          y2: y,
          lineWidth: 0.5,
          lineColor: '#e0e0e0'
        });
      }

      // วาดแท่งกราฟ
      months.forEach((month, i) => {
        const barHeight = (values[i] / maxValue) * chartHeight;
        const x = i * (barWidth + 8) + 4;
        const y = baseY - barHeight;

        canvas.push({
          type: 'rect',
          x: x,
          y: y,
          w: barWidth,
          h: barHeight,
          color: 'red'
          // color: colors[i]
          // color:'#' + Math.floor(Math.random()*16777215).toString(16)
        });
      });
      return canvas;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );
      this.dataforprint.title = copany_datat.data[0].name;
    },
    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  },
};
